import { t } from "i18next";
import jsPDF from "jspdf";
import autoTable, { jsPDFDocument, Styles } from "jspdf-autotable";

import { ADMIN_DELIVERIES_LABELS } from "../../constants";
import {
  DeliveriesLabels,
  DriverInDeliveriesListItem
} from "../../financial.types";

interface RenderTableProps {
  pdf: jsPDF;
  normalFontStyles: Partial<Styles>;
  driver: DriverInDeliveriesListItem;
  labels?: DeliveriesLabels;
}
export const renderSummary = ({
  pdf,
  normalFontStyles,
  driver,
  labels = ADMIN_DELIVERIES_LABELS
}: RenderTableProps) => {
  const summaryDataTextStyle: Partial<Styles> = {
    valign: "middle",
    halign: "center",
    ...normalFontStyles,
    fontStyle: "normal"
  };

  autoTable(pdf, {
    theme: "plain",
    startY: (pdf as jsPDFDocument).lastAutoTable.finalY ?? 80,
    head: [
      [
        {
          content: t(labels.toCollect),
          styles: {
            valign: "middle",
            halign: "center",
            ...normalFontStyles
          }
        },
        {
          content: t(labels.toPay),
          styles: {
            valign: "middle",
            halign: "center",
            ...normalFontStyles
          }
        },
        {
          content: t(labels.paid),
          styles: {
            valign: "middle",
            halign: "center",
            ...normalFontStyles
          }
        },
        {
          content: t(labels.collected),
          styles: {
            valign: "middle",
            halign: "center",
            ...normalFontStyles
          }
        }
      ]
    ],
    body: [
      [
        { content: driver.totalAmountToCollect.toLocaleString("en-US") },
        { content: driver.totalAmountToPay.toLocaleString("en-US") },
        { content: driver.totalAmountPaid.toLocaleString("en-US") },
        { content: driver.totalAmountCollected.toLocaleString("en-US") }
      ]
    ],
    headStyles: normalFontStyles,
    styles: {
      cellPadding: 3,
      lineWidth: 1,
      lineColor: "#FFF",
      ...summaryDataTextStyle
    },
    tableLineWidth: 0,
    tableLineColor: "#FFF"
  });
};
